<script setup lang="ts">
import type { FacilityID } from '../../cross-app-shared/types/db';
import { Sheet, SheetContent } from '../sheet';
import { watchAndFetch } from '../watch-and-fetch';
import { crossAppActions } from '../cross-app-actions';
import FacilityFullDetailsEditor from './FacilityFullDetailsEditor.vue';
import { toRef } from 'vue';

const props = defineProps<{ facilityID: FacilityID }>();
const isOpen = defineModel<boolean>('isOpen', { required: true });

const { response: facility, loading: facilityIsLoading } = watchAndFetch(
  toRef(props, 'facilityID'),
  null,
  async (facilityID) => {
    return await crossAppActions.facilities.detailsGet(facilityID);
  },
);
</script>

<template>
  <Sheet v-model:open="isOpen">
    <SheetContent style="overflow: auto" class="w-full sm:max-w-[1200px]">
      <template v-if="facilityIsLoading">
        <i class="fa fa-spin fa-spinner-third"></i>
        Loading facility details...
      </template>
      <FacilityFullDetailsEditor
        v-else-if="facility"
        :key="facility.facilityID"
        :readonly="false"
        :apps="facility.apps"
        mode="update"
        v-model="facility"
      >
        <template v-if="$slots['extra-sections']" #extra-sections>
          <slot name="extra-sections" :facility="facility" />
        </template>
      </FacilityFullDetailsEditor>
    </SheetContent>
  </Sheet>
</template>
